import axios from "axios";
export const ConfirmPasswordAPI = {
  data: () => ({}),
  methods: {
    async ConfirmPasswordAPIMethod(user_email_id, new_password, session) {
      try {
        var data = JSON.stringify({
          command: "changeTemporaryPassword",
          user_email_id,
          new_password,
          session,
        });
        var config = {
          method: "post",
          maxBodyLength: Infinity,
          url: "https://cmjo10iqb9.execute-api.ap-south-1.amazonaws.com/dev/user_auth/signin",
          headers: {},
          data: data,
        };

        let result = await axios(config);
        return result;
      } catch (error) {
        return {
          status: error.response.status,
          statusText: "FAILURE",
          error: error.response.data.Model,
        };
      }
    },
  },
};
